var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"color-label"},[_c('div',{staticClass:"circle",style:({ background: _vm.color })}),_c('div',{staticClass:"label"},[_c('div',[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.color))]),(_vm.note!=null)?_c('span',{staticClass:"text"},[_vm._v(" | "+_vm._s(_vm.note))]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }